import { HTTPStatusCode } from "@libs/api/types";
import { HouseholdUpdateType } from "@/domain/household";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const HouseholdsApi = {
  getHousehold: async (id: string) => {
    const res = await tsRestClient().households.getHousehold({
      params: { id },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in HouseholdsApi.getHousehold",
      error: res.body,
      shouldThrowError: true,
    });
  },
  updateHousehold: async (id: string, data: HouseholdUpdateType) => {
    const res = await tsRestClient().households.updateHousehold({
      params: { id },
      body: data,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in HouseholdsApi.updateHousehold",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
